var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCameraActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "89.541%",
    x2: "0%",
    y2: "10.459%",
    id: "sgqd72rpea"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "98.817%",
    x2: "0%",
    y2: "1.183%",
    id: "qatlfvwisb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "1.183%",
    x2: "97.491%",
    y2: "98.817%",
    id: "q9nznzteyc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACF00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A100",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.446 6.726c.464 0 .885.185 1.19.486a1.638 1.638 0 0 1 0 2.338 1.688 1.688 0 0 1-1.19.486H17.66c-.678 0-1.329.267-1.808.74l-1.757 1.737a5.96 5.96 0 0 1-4.189 1.714H6.361c-.706 0-1.345.283-1.808.74a2.515 2.515 0 0 0-.752 1.795v20.952c0 .701.287 1.336.752 1.795.463.457 1.102.74 1.808.74h29.687c.707 0 1.346-.283 1.809-.74.465-.46.752-1.094.752-1.795V23.048c0-.457.187-.87.49-1.169a1.688 1.688 0 0 1 1.19-.487c.465 0 .886.186 1.19.487.303.3.49.712.49 1.169v14.666a5.79 5.79 0 0 1-1.732 4.132 5.941 5.941 0 0 1-4.189 1.714H6.361a5.941 5.941 0 0 1-4.189-1.714A5.79 5.79 0 0 1 .44 37.714V16.762a5.79 5.79 0 0 1 1.732-4.132 5.941 5.941 0 0 1 4.19-1.714h3.544c.678 0 1.329-.267 1.809-.74L13.47 8.44a5.96 5.96 0 0 1 4.19-1.714z",
    stroke: "#000",
    strokeWidth: 0.88,
    fill: "url(#sgqd72rpea)",
    transform: "translate(0 .022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.205 17.202c2.807 0 5.348 1.124 7.188 2.941a9.943 9.943 0 0 1 2.974 7.095c0 2.77-1.137 5.28-2.974 7.095a10.195 10.195 0 0 1-7.188 2.941 10.195 10.195 0 0 1-7.188-2.941 9.943 9.943 0 0 1-2.975-7.095c0-2.77 1.137-5.279 2.975-7.095a10.195 10.195 0 0 1 7.188-2.941zm0 3.31a6.819 6.819 0 0 0-4.808 1.968 6.667 6.667 0 0 0-1.994 4.758c0 1.858.762 3.54 1.994 4.758a6.819 6.819 0 0 0 4.808 1.968 6.819 6.819 0 0 0 4.807-1.968 6.667 6.667 0 0 0 1.994-4.758c0-1.858-.761-3.54-1.994-4.758a6.819 6.819 0 0 0-4.807-1.968z",
    stroke: "#000",
    strokeWidth: 0.88,
    fill: "url(#qatlfvwisb)",
    transform: "translate(0 .022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.518 0c1.171 0 2.12.938 2.12 2.095v4.19h4.242c1.17 0 2.12.939 2.12 2.096s-.95 2.095-2.12 2.095h-4.242v4.19c0 1.158-.949 2.096-2.12 2.096-1.171 0-2.12-.938-2.12-2.095v-4.191h-4.241c-1.172 0-2.12-.938-2.12-2.095 0-1.157.948-2.095 2.12-2.095l4.24-.001v-4.19c0-1.157.95-2.095 2.121-2.095z",
    fill: "url(#q9nznzteyc)",
    transform: "translate(0 .022)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraActive);
export default __webpack_public_path__ + "static/media/ic_camera_active.c52bbb250124ea28ae9a5dc871911a84.svg";
export { ForwardRef as ReactComponent };